// extracted by mini-css-extract-plugin
export var sliderWrapper = "Slider-module--slider-wrapper--y-q+t";
export var slider = "Slider-module--slider--sdtCj";
export var arrow = "Slider-module--arrow--dkuVs";